import { type FC } from 'react';

import { HeaderSecondaryModalProps } from '@/components/AdvertisePayments/components/Header/Header.types';
import { ArrowBackIcon } from '@/components/ui/Icons/Icons';

import * as S from './Header.styles';

export const HeaderSecondaryModal: FC<HeaderSecondaryModalProps> = ({
  contentTitle,
  onBack
}: HeaderSecondaryModalProps) => {
  return (
    <S.ModalHeader $isBack={true}>
      <S.ModalHeaderSection>
        <S.ModalBackButton onClick={onBack}>
          <ArrowBackIcon />
        </S.ModalBackButton>
        <S.ModalTitle>{contentTitle}</S.ModalTitle>
      </S.ModalHeaderSection>
    </S.ModalHeader>
  );
};
